// extracted by mini-css-extract-plugin
export default {"header":"styleAppbar_header__Ymy8N","nav":"styleAppbar_nav__Y6a8J"};